import {Injectable} from "@angular/core";
import {MasterAsideService} from "./aside/master-aside.service";
import {IContainerAsideComponent} from "../shared/interfaces/configuracion";

@Injectable()
export class TramiteAsideService extends MasterAsideService {


  getMenuItems(translations: any, isLoggedIn: boolean, props?: any): IContainerAsideComponent[] {

    return [

      {
        visible: isLoggedIn,
        class: 'mt-3',
        items: [
          {
            index: 0,
            title: translations.misPagos,
            content: translations.misPagosDescripcion,
            icon: 'pi  pi-credit-card',
            descripcionCard: translations.verMisPagos,
            command: (event: any) => props.redirect('/tramites/mis-pagos'),

          },
          {
            index: 1,
            title: translations.misFacturas,
            content: translations.misFacturaDescripcion,
            icon: 'pi pi-receipt',
            descripcionCard: translations.verMisFacturas,
            command: (event: any) => props.redirect('/tramites/mis-facturas'),

          },
        ]
      }
    ]

  }




}
